import { l } from '@manychat/manyui'

export const MAX_CUSTOM_LABELS = 5

export enum ACTION {
  CREATE = 'create',
  EDIT = 'edit',
  VIEW = 'view',
  DELETE = 'delete',
}

export const MODAL_TITLES = (name?: string) => {
  return {
    [ACTION.CREATE]: l.makeTranslate('Create a new label'),
    [ACTION.EDIT]: l.makeTranslate('Edit label'),
    [ACTION.VIEW]: name,
    [ACTION.DELETE]: l.makeTranslate('Delete label?'),
  }
}

export const ANALYTICS_EVENTS = {
  LABEL_CREATE_OPENED: 'label_create_opened',
  LABEL_CREATED: 'label_created',
  LABEL_CREATE_FAILED: 'label_create_failed',
  LABEL_PREVIEW_CLICKED: 'label_preview_clicked',
  LABEL_VIEW_OPENED: 'label_view_opened',
  LABEL_THREAD_ADDED_MANUAL: 'label_thread_added_manual',
  LABEL_THREAD_REMOVED_MANUAL: 'label_thread_removed_manual',
  LABEL_EDIT_OPENED: 'label_edit_opened',
  LABEL_EDITED: 'label_edited',
  LABEL_EDIT_FAILED: 'label_edit_failed',
  LABEL_DELETE_OPENED: 'label_delete_opened',
  LABEL_DELETED: 'label_deleted',
  LABEL_DELETE_FAILED: 'label_delete_failed',
  LABEL_LIMIT_REACHED_VIEWED: 'label_limit_reached_viewed',
}
